export default "__VITE_ASSET__k19b37ne__"